/* SPEED (Oct 2026, Careberry): the 480 KB pincode list (pincode-list.js) is now loaded on demand -
   when the shopper focuses the pincode box or presses Check, or right away only if a pincode was saved
   earlier in this session. Messages and behaviour are unchanged. */
if ($("#kshipit").length) {
  var exispincode = '';
  if (typeof(Storage) !== "undefined") {
    exispincode = sessionStorage.getItem("pincode");
  }
  $("#chkpin").val(exispincode);
  $('#pinresult').hide();

  var tat = 0;
  var toCurrentHourPlus = 0;
  var ziplistpre = null;
  var ziplistcod = null;
  var careberryPinListPromise = null;

  function careberryLoadPinList() {
    if (ziplistpre && ziplistcod) { return Promise.resolve(); }
    if (careberryPinListPromise) { return careberryPinListPromise; }
    careberryPinListPromise = new Promise(function (resolve, reject) {
      function parseLists() {
        ziplistpre = JSON.parse(ziplistpredt);
        ziplistcod = JSON.parse(ziplistcoddt);
        resolve();
      }
      if (typeof ziplistpredt !== "undefined" && typeof ziplistcoddt !== "undefined") { parseLists(); return; }
      var s = document.createElement('script');
      s.src = window.CAREBERRY_PINCODE_LIST_URL;
      s.async = true;
      s.onload = function () { try { parseLists(); } catch (e) { careberryPinListPromise = null; reject(e); } };
      s.onerror = function (e) { careberryPinListPromise = null; reject(e); };
      document.head.appendChild(s);
    });
    return careberryPinListPromise;
  }

  var careberryTruck = '<svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg>';

  /* fromClick = true for the Check button, false when restoring a saved pincode on page load
     (the original code showed slightly different messages in the two cases; kept as-is). */
  function careberryShowPincodeResult(pin, fromClick) {
    var selzip = ziplistpre[pin];
    var selzipcod = ziplistcod[pin];
    $('.checkpinerr').html("");
    $('.pincodersltpre').html("");

    if (selzip !== undefined) {
      if (selzip == "#N/A") {
        if (fromClick) {
          $('.pincodersltpre').html('<span style="font-weight:600;">Sorry...!</span> Prepaid Service Not available for this pincode.');
        } else {
          $('.pincodersltpre').html('<span style="color:red;"><span style="font-weight:600;">Sorry...!</span> Prepaid Service Not available for this pincode.</span>');
        }
      } else {
        tat = parseInt(selzip);
        var frmdt = caldays(toCurrentHourPlus, tat);
        $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper">' + careberryTruck + '<span> Your order is expected to arrive within 5-7 days.');
      }
    }
    else if (selzipcod !== undefined) {
      $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper">' + careberryTruck + 'Expected Delivery Time: 3-6 Working Days</p>');
      if (selzipcod == "Not serviceable") {
        if (fromClick) {
          $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper">' + careberryTruck + '<span>Expected Delivery Time: 3-6 Working Days.</span></p><span style="color:red;"> Sorry! Cash on Delivery is not available for this pincode!</span>');
        } else {
          $('.pincodersltpre').html('<span style="color:red;">Sorry! Cash on Delivery is not available for this pincode!</span>');
        }
      }
      if (selzip == selzipcod) {
        $('.pincodersltpre').html('');
      }
    }
    else {
      $('.pincodersltpre').html('<span style="color:red;">Please enter valid pincode!</span>');
    }
    $('#pinresult').show();
  }

  $("#chkpin").one("focus touchstart", function () { careberryLoadPinList().catch(function () {}); });

  $(".tickbtn").on("click", function () {
    var pin = $("#chkpin").val();
    if (typeof(Storage) !== "undefined") {
      sessionStorage.setItem("pincode", pin);
    }
    careberryLoadPinList().then(function () {
      careberryShowPincodeResult(pin, true);
    }).catch(function () {
      $('.pincodersltpre').html('<span style="color:red;">Could not check this pincode right now. Please try again.</span>');
      $('#pinresult').show();
    });
  });

  $(window).on('load', function () {
    if (exispincode != null) {
      careberryLoadPinList().then(function () {
        careberryShowPincodeResult(exispincode, false);
      }).catch(function () {});
    }
  });

  function caldays(toCurrentHourPlus, tatdays) {
    if (tatdays == '24') {
      tatdays = 1;
    }
    else if (tatdays == '48') {
      tatdays = 2;
    }
    else if (tatdays == '72') {
      tatdays = 3;
    }
    else if (tatdays == '96') {
      tatdays = 4;
    } else if (tatdays == '120') {
      tatdays = 5;
    }

    var toCurrentDate = new Date();
    var toCurrentHour = toCurrentDate.getHours();

    if (toCurrentHour >= 14) { toCurrentHourPlus = toCurrentHourPlus + 1; }
    if (tatdays > 0) {
      toCurrentHourPlus = toCurrentHourPlus + tatdays;
    }
    var fromDate = Date.today().addDays(toCurrentHourPlus);

    if (fromDate.is().sunday()) {
      fromDate = fromDate.next().monday();
    }
    var seldt = fromDate.toString('ddd, MMM dS');
    var toDate = fromDate.addDays(1);
    var selltoDate = toDate.toString('ddd, MMM dS');

    var finalDates = seldt + " to " + selltoDate;
    return finalDates;
  }
}
